import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ArticlePage = lazy(() => import('../pages/article/page'));
const Iwin68Page = lazy(() => import('../pages/article/iwin68-page'));
const CategoryPage = lazy(() => import('../pages/category/page'));
const TinGamePage = lazy(() => import('../pages/tin-game/page'));
const FifaOnline4PillarPage = lazy(() => import('../pages/pillar/fifa-online-4'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/bai-viet/huong-dan-nap-tien-iwin68-nhanh-bao-mat-khong-loi-2025',
    element: <Iwin68Page />,
  },
  {
    path: '/bai-viet/:slug',
    element: <ArticlePage />,
  },
  {
    path: '/fifa-online-4',
    element: <CategoryPage />,
  },
  {
    path: '/age-of-empires',
    element: <CategoryPage />,
  },
  {
    path: '/lien-minh-huyen-thoai',
    element: <CategoryPage />,
  },
  {
    path: '/csgo',
    element: <CategoryPage />,
  },
  {
    path: '/pubg',
    element: <CategoryPage />,
  },
  {
    path: '/tin-game',
    element: <TinGamePage />,
  },
  {
    path: '/fifa-online-4/huong-dan-toan-tap',
    element: <FifaOnline4PillarPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;